import { OrganisationPermissionsType } from 'worldover/hooks/use-get-permissions/use-get-permissions';
import { DateFormat, formatDate } from 'worldover/lib/date';
import { Text } from 'worldover/ui-components';

import { LandingPageFreeTierBookDemo } from './LandingPageFreeTierBookDemo';
import { LandingPageFreeTierHome } from './LandingPageFreeTierHome';
import { LandingPageFreeTierNewsletterCard } from './LandingPageFreeTierNewsletterCard';

interface Props {
  firstName: string | undefined;
  organisationPermissions: OrganisationPermissionsType;
}

export const LandingPageFreeTier = ({
  firstName,
  organisationPermissions,
}: Props) => {
  return (
    <div className='flex flex-col gap-[40px] m-auto mt-4 p-8 max-w-[1200px]'>
      <div className='flex flex-col gap-6'>
        {firstName && (
          <Text variant='heading3' color='text-slate-800' ariaLabel="welcome-message">
            Good {formatDate(DateFormat.TimeOfDay)} {firstName}
          </Text>
        )}
        <Text variant='largeReg' color='text-slate-500'>
          What would you like to do today?
        </Text>
      </div>
      <LandingPageFreeTierHome
        organisationPermissions={organisationPermissions}
      />
      <div className='grid grid-cols-2 gap-[40px] w-full'>
        <LandingPageFreeTierNewsletterCard />
        <LandingPageFreeTierBookDemo />
      </div>
    </div>
  );
};
